import React from 'react'

import { connect } from 'react-redux'

import { findEntity } from 'selectors/entities';
import { Item, Segment } from "semantic-ui-react";
import TimelineNode from "./TimelineNode";

export class DossierCreationNode extends React.Component {
  constructor(props) {
    super(props)
    this.state = {collapsed: true}
  }

  render() {
    const {isSelected, dossier, attributes} = this.props

    if (!dossier) {
      return <div>{I18n.t('components.dossier_item.not_loaded')}</div>
    }

    return (<div {...attributes}>

      <TimelineNode {...this.props} time={dossier && dossier.createdAt} last={true}
                    icon='user circle outline'>
        <Item as={Segment} raised={isSelected} clearing contentEditable={false}>
          {"Dossier aangemaakt"}
        </Item>
      </TimelineNode>
    </div>)
  }
}

const mapStateToProps = (state, ownProps) => {
  let dossier = findEntity(state, 'dossier', ownProps.dossierId)


  return {
    dossier: dossier
  }
}

export default connect(mapStateToProps)(DossierCreationNode)

